module.exports = __webpack_public_path__ + "static/media/logo.66e3f197.svg";